import axios from "./axios";

export async function fetchHours(controller) {
  return axios({
    method: "get",
    url: "/hours",
    params: controller,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function fetchHour(id, options = {}) {
  return axios.get(`/hours/` + id, options);
}

export async function fetchHoursCount(payload) {
  return axios.get(`/hours/count`, {
    params: payload,
  });
}

export async function fetchHourSettings() {
  return axios.get(`/hours/settings`);
}

export async function fetchHourRegistrationPolicy() {
  return axios.get(`/hours/registration_policy`);
}

export async function updateHourSettings(payload) {
  return axios
    .put(`/hours/settings/`, { settings: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function queueFetchHoursJob(params) {
  // Expects: { from_date: 'YYYY-MM-DD', to_date: 'YYYY-MM-DD', user_id: number | null }
  return axios
    .post(`/tripletex/fetch_hours`, params)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response?.data || error;
    });
}

export async function createHour(payload) {
  return axios
    .post(`/hours`, { hour: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}
export async function updateHour(payload) {
  return axios
    .put(`/hours/${payload.id}`, { hour: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

/** PATCH /hours/bulk_reassign — move many hours to a project activity line */
export async function bulkReassignHours({ hour_ids, project_activity_id }) {
  const res = await axios.patch(
    `/hours/bulk_reassign`,
    {
      hour_ids,
      project_activity_id,
    },
    { validateStatus: (status) => [200, 422].includes(status) }
  );
  if (res.status && res.status >= 400 && res.status !== 422) {
    const err = new Error("bulk_reassign_failed");
    err.response = res;
    throw err;
  }
  return res.data;
}

export async function deleteHour(id) {
  return axios
    .delete(`/hours/${id}`)

    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function fetchHoursMonthlyOverview(params = {}) {
  return axios.get(`/hours/monthly_overview`, { params });
}

export async function updateHoursMonthlyOverviewUnlock(payload) {
  return axios.put(`/hours/monthly_overview/unlock`, payload);
}

export async function fetchHoursResourcePlan(params = {}) {
  return axios.get(`/hours/resource_plan`, { params });
}
